

import { useTranslation } from 'react-i18next'
import { IconSearch } from '@tabler/icons-react'
import './styles.scss'

import { Input } from '@fragments'

export default function Search() {
    const { t } = useTranslation('shell')

    return (
        <div className="cs-sidebar-search mt-3">
            <Input
                placeholder={t('sidebar.searchPlaceholder')}
                end={<IconSearch />}
                className="search-sidebar"
            />
        </div>
    )
}